import { ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

export function dateRangeValidator(dateFromControlName: string, dateToControlName: string): ValidatorFn {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const dateFromControl = formGroup.get(dateFromControlName);
    const dateToControl = formGroup.get(dateToControlName);

    if (!dateFromControl || !dateToControl) {
      return null;
    }

    // Manejo de valores nulos/undefined
    const dateFromValue = dateFromControl.value;
    const dateToValue = dateToControl.value;

    if (!dateFromValue || !dateToValue) {
      return null; // Permitir que Validators.required maneje la validación de campos vacíos
    }

    // Conversión segura de fechas
    const dateFrom = new Date(dateFromValue);
    const dateTo = new Date(dateToValue);

    // Validar que las fechas sean válidas
    if (isNaN(dateFrom.getTime()) || isNaN(dateTo.getTime())) {
      return { dateRangeError: true };
    }

    // Validación de orden cronológico
    if (dateFrom.getTime() > dateTo.getTime()) {
      return { dateRangeError: true };
    }

    // Validación de rango máximo de 31 días
    const daysDifference = Math.ceil((dateTo.getTime() - dateFrom.getTime()) / (1000 * 60 * 60 * 24));
    if (daysDifference > 31) {
      return { dateRangeExceeds31Days: true };
    }

    return null;
  };
}
